import { slugify } from "transliteration";

export const getSlugifiedString = (initialString: string): string => {
  const slug = slugify(initialString, { lowercase: true, separator: "" });

  return slug.replace(/(\W|_)/g, "");
};
